import styled from 'styled-components';

const CloseIcon = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg xmlns="http://www.w3.org/2000/svg" width="11.414" height="11.414" viewBox="0 0 11.414 11.414" {...props}>
    <path
      fill="#333333"
      stroke="#333333"
      d="M7.027-24.3l-.7.7 4.3 4.3-4.3 4.3.7.7 4.3-4.3 4.3 4.3.7-.7-4.3-4.3 4.3-4.3-.7-.7-4.3 4.3z"
      transform="translate(-5.616 25.009)"
    />
  </svg>
);

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
`;

const CloseButton = ({ ...props }) => {
  return <StyledCloseIcon {...props} />;
};

/** @component */
export default CloseButton;
